import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/common/img-404.png'
import _imports_1 from '@/assets/img/common/img-pagetop.svg'


const _withScopeId = n => (_pushScopeId("data-v-446c3f4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "l-wrapper" }
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = { class: "p-notfound" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-notfound_img" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", null, "404"),
    /*#__PURE__*/_createElementVNode("span", null, "error"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("span", null, "Not Found")
  ]),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "お探しのページが見つかりませんでした。", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("お探しのページは一時的にアクセスができない状況にあるか、"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("リンクが無効になっている可能性がございます。")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "お手数ですが、以下より他のページをご覧くださいませ。", -1))
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "l-wrapper_nav" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "g-pagetop",
    href: "#",
    "aria-label": "ページトップへ戻る"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: ""
    })
  ])
], -1))

import { useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'NotFoundView',
  setup(__props) {

const router = useRouter();

const transitionTopPage = () => {
  router.push({ name: 'f00' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("main", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("p", null, [
            _createElementVNode("a", {
              href: "#",
              onClick: _withModifiers(transitionTopPage, ["prevent"])
            }, "ホームへ", 8, _hoisted_8)
          ])
        ])
      ])
    ]),
    _hoisted_9
  ], 64))
}
}

})